export default class ContactUsPage {
    constructor() {
        console.info('ContactUsPage.constructor()');

        this.initListeners();
    }

    initListeners() {
        console.info('ContactUsPage.initListeners()');

        $('#contact-form').parsley();

        // Field validation : toggle aria-invalid for screenreaders
        window.Parsley.on('field:error', function () {
            $(this.$element).attr('aria-invalid', 'true');
        });
        window.Parsley.on('field:success', function () {
            $(this.$element).attr('aria-invalid', 'false');
        });

        $('#contact-form').on('submit', (e) => {
            e.preventDefault();

            const $action = $('#contact-form').attr('action');
            const $firstName = `First Name = ${$('#contact-form').find('input[name="first_name"]').val()}`;
            const $lastName = `%0D%0A%0D%0ALast Name = ${$('#contact-form').find('input[name="last_name"]').val()}`;
            const $emailAddress = `%0D%0A%0D%0AEmail Address = ${$('#contact-form')
                .find('input[name="email_address"]')
                .val()}`;
            const $confirmEmailAddress = `%0D%0A%0D%0AConfirm Email Address = ${$('#contact-form')
                .find('input[name="confirm_email_address"]')
                .val()}`;
            const $productType = `%0D%0A%0D%0AProduct Type = ${$('#contact-form')
                .find('select[name="type_product"]')
                .val()}`;
            const $hearAboutSite = `%0D%0A%0D%0AWhat would you like to tell us? = ${$('#contact-form')
                .find('select[name="hear_about_site"]')
                .val()}`;
            const $phoneNumber = `%0D%0A%0D%0APhone Number = ${$('#contact-form')
                .find('input[name="phonenumber"]')
                .val()}`;
            const $message = `%0D%0A%0D%0AMessage = ${$('#contact-form').find('textarea[name="message"]').val()}`;

            const $bodyMessage =
                $firstName +
                $lastName +
                $emailAddress +
                $confirmEmailAddress +
                $productType +
                $hearAboutSite +
                $phoneNumber +
                $message;
            const mailto_link = `${$action}&body=${$bodyMessage}`;

            const win = window.open(mailto_link, 'emailWindow');
        });
    }
}
